'use strict';
angular.module('externalSystemRouterModule', [])
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider,
        $urlRouterProvider) {
        $stateProvider.state('front.editctr.app.waitcompiled.externalsystem', {
            url: '/externalsystem?externalsystemurl',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/externalSystem/externalSystem_tpl.html',
                    controller: 'appExternalSystemController'
                }
            }
        }).state('front.editctr.app.pending.externalsystem', {
            url: '/externalsystem?externalsystemurl',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/externalSystem/externalSystem_tpl.html',
                    controller: 'appExternalSystemController'
                }
            }
        }).state('front.editctr.app.signed.externalsystem', {
            url: '/externalsystem?externalsystemurl',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/externalSystem/externalSystem_tpl.html',
                    controller: 'appExternalSystemController'
                }
            }
        });
    }]);